import 'css-chunksrc/client/pages/projectPage/wbsPage/filters/styles.scss';export default {
  "filters": "_filters_1d9rm_1",
  "resetButton": "_resetButton_1d9rm_9",
  "label": "_label_1d9rm_17",
  "section": "_section_1d9rm_24"
};